import { formatDay, formatUtcDay } from 'src/utils/date';

import { useHydrated } from './useHydrated';

/**
 * How a server-rendered screen prints the day of a moment the api gave it ("Created at", "available
 * from"). The storefront reads such a day on the visitor's own clock (`formatDay`), and the server
 * has no way to know that clock: it prints the UTC day, the browser's first render repeats it, and
 * the visitor's own day follows as soon as the browser has the page. For most visitors it is the
 * same day and nothing changes on screen.
 */
export const useDayFormat = (): ((moment: string | Date) => string) => (useHydrated() ? formatDay : formatUtcDay);
